var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user"},[_c('div',{staticClass:"header"},[_c('div',{staticClass:"logo",attrs:{"title":_vm.$t( 'GLOBAL_appBrand' )}})]),_c('router-view',{staticClass:"main"}),_c('Ocean')],1)}
var staticRenderFns = []

export { render, staticRenderFns }